import { __awaiter } from "tslib";
import { useCallback } from "react";
import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
import { useCsAttribute } from "./useCsAttribute";
import { useCsAttributeApi } from "./useCsAttributeApi";
import { useSingleOptionBoolValue } from "./useSingleOptionBoolValue";
const logger = new ConsoleLogger("SingleOptionBool", LogLevels.warn);
export function useSingleOptionBoolValueSelection(options) {
    const { showIndeterminate } = options;
    const attribute = useCsAttribute();
    const { toggleOption } = useCsAttributeApi();
    const { trueValue, falseValue, hasSelection } = useSingleOptionBoolValue();
    const trueSelected = Boolean(trueValue === null || trueValue === void 0 ? void 0 : trueValue.isSelected);
    const falseSelected = Boolean(falseValue === null || falseValue === void 0 ? void 0 : falseValue.isSelected);
    const truePossible = Boolean((trueValue === null || trueValue === void 0 ? void 0 : trueValue.isAllowed) && (trueValue === null || trueValue === void 0 ? void 0 : trueValue.isActive));
    const falsePossible = Boolean((falseValue === null || falseValue === void 0 ? void 0 : falseValue.isAllowed) && (falseValue === null || falseValue === void 0 ? void 0 : falseValue.isActive));
    const isIndeterminate = !hasSelection && showIndeterminate;
    const attributeCanBeChanged = Boolean(attribute.isAllowed && !attribute.isReadOnly);
    const isDisabled = !(attributeCanBeChanged &&
        ((!isIndeterminate && showIndeterminate) ||
            (!falseSelected && falsePossible) ||
            (!trueSelected && truePossible)));
    const toggleSingle = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (isDisabled) {
            return;
        }
        if (showIndeterminate) {
            // indeterminate -> true -> false -> indeterminate
            if (isIndeterminate && truePossible) {
                logger.info(attribute.id, "3-value: indeterminate → true");
                yield toggleOption(true, true);
            }
            else if (isIndeterminate && falsePossible) {
                logger.info(attribute.id, "3-value: indeterminate → false");
                yield toggleOption(false, true);
            }
            else if (trueSelected && falsePossible) {
                logger.info(attribute.id, "3-value: true → false");
                yield toggleOption(false, true);
            }
            else if (falseSelected) {
                logger.info(attribute.id, "3-value: false → indeterminate");
                yield toggleOption(false, false);
            }
            else if (trueSelected) {
                logger.info(attribute.id, "3-value: true → indeterminate");
                yield toggleOption(true, false);
            }
            else {
                logger.warn(attribute.id, "3-value: selection not possible", {
                    showIndeterminate,
                    truePossible,
                    falsePossible,
                    trueSelected,
                    falseSelected,
                });
            }
        }
        else {
            // indeterminate -> true -> false -> true
            if (!trueSelected && truePossible) {
                logger.info(attribute.id, "2-value: false → true");
                yield toggleOption(true, true);
            }
            else if (!falseSelected && falsePossible) {
                logger.info(attribute.id, "2-value: true → false");
                yield toggleOption(false, true);
            }
            else {
                logger.warn(attribute.id, "2-value: selection not possible", {
                    showIndeterminate,
                    truePossible,
                    falsePossible,
                    trueSelected,
                    falseSelected,
                });
            }
        }
    }), [
        isDisabled,
        showIndeterminate,
        isIndeterminate,
        truePossible,
        trueSelected,
        falsePossible,
        falseSelected,
        toggleOption,
        attribute.id,
    ]);
    return {
        toggleSingle,
        isIndeterminate,
        isDisabled,
        isSelected: trueSelected,
    };
}
//# sourceMappingURL=useSingleOptionBoolValueSelection.js.map